function CookieYouTube(status) {
    if (status == 'show') {
       $('.el-asset--video--cookie').hide();
    } else {
        $('.el-asset--video--cookie').show();
    }

}

function allowYouTube(e) {
    klaro.getManager().saveAndApplyConsents();
    klaro.getManager().updateConsent('youtube', true);
    klaro.getManager().saveAndApplyConsents();
}